var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"mapbox-component",attrs:{"id":_vm.mapId}},[_c('div',{class:_vm.config.type=='detail' || _vm.viewMode=='detail'?'d-none':'marker-custom'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }